import { HttpClient } from "@angular/common/http";
import { Injectable, InjectionToken, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { OAuthStorageAdapter } from "@impacgroup/angular-oauth-base";
import { ApiListQueryParameter, BaseDatatableStateSaveMode } from "@impacgroup/angular-baselib";
import { map } from "rxjs/operators";
import { plainToInstance } from "class-transformer";
import { V2AdminSimCardDetailResponseDTO, V2AdminSimCardListItemResponseDTO } from "@impacgroup/doerr-wildkamera-api-dtos";

export interface ISimCardConfigService {
    simCardsAPI: string;
    utcDateFormat: string;
    datatableStateSaveMode: BaseDatatableStateSaveMode;
}

export const SimCardConfigService = new InjectionToken<ISimCardConfigService>("SimCardConfig");

@Injectable()
export class SimCardsService {
    public UTCDATEFORMAT: string = "";
    public datatableStateSaveMode: BaseDatatableStateSaveMode;

    constructor(@Inject(SimCardConfigService) private simCardConfig: ISimCardConfigService, private http: HttpClient, private oauthStorageAdapter: OAuthStorageAdapter) {
        this.UTCDATEFORMAT = this.simCardConfig.utcDateFormat;
        this.datatableStateSaveMode = this.simCardConfig.datatableStateSaveMode;
    }

    public list(params: ApiListQueryParameter): Observable<{ list: V2AdminSimCardListItemResponseDTO[]; count: number; total: number }> {
        return this.http
            .get<object[]>(this.getSimCardsServiceUrl(""), {
                headers: this.oauthStorageAdapter.getAuthHeadersJSON(),
                params: params as any,
                observe: "response"
            })
            .pipe(
                map((result) => {
                    let count = result.body?.length ?? 0;
                    let total = result.body?.length ?? 0;
                    try {
                        count = parseInt(result.headers.get("X-Pagination-Count") ?? "0", 10);
                    } catch (e) {}
                    try {
                        total = parseInt(result.headers.get("X-Total-Count") ?? "0", 10);
                    } catch (e) {}

                    return {
                        list: plainToInstance(V2AdminSimCardListItemResponseDTO, result.body ?? []),
                        count: count,
                        total: total
                    };
                })
            );
    }

    public simCardDetail(id: string): Observable<V2AdminSimCardDetailResponseDTO> {
        return this.http
            .get<Object>(this.getSimCardsServiceUrl(id), {
                headers: this.oauthStorageAdapter.getAuthHeadersJSON()
            })
            .pipe(map((result) => plainToInstance(V2AdminSimCardDetailResponseDTO, result)));
    }

    public activateSimCard(id: string): Observable<Object> {
        return this.http.post<Object>(
            this.getSimCardsServiceUrl(`${id}/activate`),
            {},
            {
                headers: this.oauthStorageAdapter.getAuthHeadersJSON()
            }
        );
    }

    public deactivateSimCard(id: string): Observable<Object> {
        return this.http.post<Object>(
            this.getSimCardsServiceUrl(`${id}/deactivate`),
            {},
            {
                headers: this.oauthStorageAdapter.getAuthHeadersJSON()
            }
        );
    }

    private getSimCardsServiceUrl(postfix: string): string {
        return this.simCardConfig.simCardsAPI + postfix;
    }
}
